module.exports = __webpack_public_path__ + "img/gear-primary.51f3d043.svg";